import { columns } from '@ipc/ipc-components';
import column from '../../../../common/list-table/helpers/columns';

export default (data) => {
  const {
    DateTimeColumn,
  } = columns(data);
  const { FilteredTextColumn } = column(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Data shared with', 'dataSharedWith'),
        new FilteredTextColumn('Operator Type', 'operatorType'),
        new FilteredTextColumn('Data Type', 'dataType'),
        new FilteredTextColumn('Last shared file', 'lastSharedFile').withWidth(400),
        new DateTimeColumn('Last shared', 'lastSharedDate'),
        new DateTimeColumn('Last retrieved', 'lastRetrievedDate'),
      ],
    },
  ];
};
